import { RangeProgress } from '@app/shared/ui/atoms/Multimedia';

interface PlayerProgressBarProps {
  currentTime: number;
  duration: number;
}

export const PlayerProgressBar = ({ currentTime, duration }: PlayerProgressBarProps) => {
  const formatTime = (sec: number) => {
    const m = Math.floor(sec / 60);
    const s = (sec % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  const current = Math.floor(currentTime);
  const remaining = Math.max(duration - current, 0);

  return (
    <div className="flex items-center gap-3 my-1 text-sm opacity-90">
      <span>{formatTime(current)}</span>

      <RangeProgress min={0} max={duration} value={currentTime} />

      <span>-{formatTime(Math.floor(remaining))}</span>
    </div>
  );
};
